import {styled} from "@mui/material/styles";
import {Link as RouterLink} from 'react-router-dom';

export const FooterSection = styled('section')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  backgroundColor: theme.daPalette.black.main,
  padding: theme.spacing(2),
  minHeight: theme.spacing(6),
  width: '100%',
  boxSizing: 'border-box',
  position: 'fixed',
  left: 0,
  bottom: 0,
  zIndex: 1201,
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(1),
    minHeight: theme.spacing(4),
  },
}));

export const Copyright = styled('div')(({ theme }) => ({
  fontSize: '0.75rem',
  color: theme.daPalette.black.contrastText,
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  textAlign: 'center',
  [theme.breakpoints.down('sm')]: {
    fontSize: '0.7rem',
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    marginTop: theme.spacing(1),
  },
}));

export const FooterLink = styled(RouterLink)(({ theme }) => ({
  fontSize: '0.75rem',
  color: theme.daPalette.black.contrastText,
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  cursor: 'pointer',
  textDecoration: 'none',
  display: 'inline-block',
  [theme.breakpoints.down('sm')]: {
    fontSize: '0.7rem',
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    marginBottom: theme.spacing(0.5),
  },
  '&:hover': {
      textDecoration: 'underline',
  },
}));
